import React from "react";
import styles from "./Events.module.css";
import FestiveSection from "../components/TourSection/FestiveSection";
import TestimonialSection from "../components/TestimonialSection/TestimonialSection";
import PilgrimageTourSection from "../components/HikingSection/PilgrimageTourSection";
import AdventureInfo from "../components/MembershipInfo/AdventureInfo";

function Events() {
  return (
    <>
    <section
          className="d-flex flex-column justify-content-center align-items-center text-center"
          style={{
            height: '30vh',
            backgroundImage: "url('/images/unsplash4.jpg')",
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            color: 'white',
            padding: '40px 10px'
          }}
        >
          <h1
            style={{
              fontSize: 'clamp(28px, 5vw, 42px)',
              fontWeight: 'bold',
              color: 'white'
            }}
          >
            EVENTS
          </h1>
        </section>

      <div className={styles.appContainer}>
        <main className={styles.mainGrid}>
          <AdventureInfo />
          <FestiveSection />
          <PilgrimageTourSection/>
          <TestimonialSection />
        </main>
      </div>
    </>
  );
}

export default Events;
